import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "pageCount", "currentPage", "getPageLink", "isLoading", "emptyContent", "columns", "data", "rowHeader", "sort", "onRequestSort", "a11yLabels", "pl", "pr", "stickyHeaderOffset", "mobileViewBreakpoint", "headerRenderer", "isSelectionTable", "selectedItems", "onChangeSelectedItems", "getItemLabel", "itemKey", "mobileSelectionContent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Landmark from 'components/Landmark';
import Card from 'components/Card';
import StickyBox from 'components/StickyBox';
import Table, { Column, SelectionTable, InteractiveTableContent } from 'components/Table';
import Pagination from 'components/Pagination';
import { borderValue } from 'styles/mixins';
import { getSolidBackgroundShade, pxToRem } from 'utils/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var tableRowHeight = 62;
var PaginationWrapper = styled(StickyBox).withConfig({
  displayName: "TableCard__PaginationWrapper",
  componentId: "sc-gudhjo-0"
})(["display:flex;align-items:center;min-height:", ";padding:", " ", ";background-color:", ";border-top:", ";border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;@media (max-width:", ") and (max-height:580px){position:relative !important;}"], pxToRem(tableRowHeight), function (p) {
  return p.theme.globals.spacing.s;
}, function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return getSolidBackgroundShade(p.theme);
}, function (p) {
  return borderValue(p.theme);
}, function (p) {
  return p.theme.globals.breakpoints.xs;
});
function TableCard(_ref) {
  var children = _ref.children,
    pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    getPageLink = _ref.getPageLink,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    emptyContent = _ref.emptyContent,
    columns = _ref.columns,
    data = _ref.data,
    rowHeader = _ref.rowHeader,
    sort = _ref.sort,
    onRequestSort = _ref.onRequestSort,
    a11yLabels = _ref.a11yLabels,
    pl = _ref.pl,
    pr = _ref.pr,
    stickyHeaderOffset = _ref.stickyHeaderOffset,
    mobileViewBreakpoint = _ref.mobileViewBreakpoint,
    headerRenderer = _ref.headerRenderer,
    _ref$isSelectionTable = _ref.isSelectionTable,
    isSelectionTable = _ref$isSelectionTable === void 0 ? false : _ref$isSelectionTable,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
    onChangeSelectedItems = _ref.onChangeSelectedItems,
    getItemLabel = _ref.getItemLabel,
    itemKey = _ref.itemKey,
    mobileSelectionContent = _ref.mobileSelectionContent,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function noopSelectionHandler(selectedItems) {
    void selectedItems;
  }
  var resolvedEmptyContent = isLoading ? /*#__PURE__*/_jsx(Landmark, {
    icon: "spinner",
    height: 250,
    children: t('loading')
  }) : emptyContent;
  var resolvedSelectionEmptyContent = isLoading ? /*#__PURE__*/_jsx(Landmark, {
    icon: "spinner",
    height: 250,
    children: t('loading')
  }) : emptyContent === null || emptyContent === undefined || typeof emptyContent === 'boolean' ? undefined : /*#__PURE__*/React.isValidElement(emptyContent) ? emptyContent : (/*#__PURE__*/React.createElement(React.Fragment, null, emptyContent));
  var selectionChangeHandler = onChangeSelectedItems || noopSelectionHandler;
  var selectionHeaderRenderer = headerRenderer === undefined ? undefined : headerRenderer;
  var selectionTableProps = {
    columns: columns,
    data: data,
    rowHeader: rowHeader,
    sort: sort,
    onRequestSort: onRequestSort,
    a11yLabels: a11yLabels,
    pl: pl,
    pr: pr,
    emptyContent: resolvedSelectionEmptyContent,
    headerRenderer: selectionHeaderRenderer,
    shadedHeader: true,
    rowMinHeight: tableRowHeight,
    stickyHeaderOffset: stickyHeaderOffset,
    mobileViewBreakpoint: mobileViewBreakpoint,
    selectedItems: selectedItems,
    onChangeSelectedItems: selectionChangeHandler,
    getItemLabel: getItemLabel,
    itemKey: itemKey,
    mobileSelectionContent: mobileSelectionContent
  };
  return /*#__PURE__*/_jsxs(Card, {
    overflow: "visible",
    children: [isSelectionTable ? /*#__PURE__*/_jsx(SelectionTable, _objectSpread(_objectSpread({}, selectionTableProps), {}, {
      children: children
    })) : /*#__PURE__*/_jsx(Table, _objectSpread(_objectSpread({}, otherProps), {}, {
      columns: columns,
      data: data,
      rowHeader: rowHeader,
      sort: sort,
      onRequestSort: onRequestSort,
      a11yLabels: a11yLabels,
      pl: pl,
      pr: pr,
      emptyContent: resolvedEmptyContent,
      headerRenderer: headerRenderer,
      shadedHeader: true,
      rowMinHeight: tableRowHeight,
      stickyHeaderOffset: stickyHeaderOffset,
      mobileViewBreakpoint: mobileViewBreakpoint,
      children: children
    })), /*#__PURE__*/_jsx(PaginationWrapper, {
      placement: "bottom",
      children: /*#__PURE__*/_jsx(Pagination, {
        pageCount: pageCount,
        currentPage: currentPage,
        getPageLink: getPageLink,
        disableNavigation: isLoading,
        desktopViewBreakpoint: mobileViewBreakpoint
      })
    })]
  });
}
export { Column };
export { InteractiveTableContent };
export default TableCard;